import { googleAdManagerId, debugTrackingEnabled } from 'reactAppConstants';

const normalizePhoneToE164 = (phoneNumber) => {
  if (!phoneNumber || typeof phoneNumber !== 'string') return null;
  const digits = phoneNumber.replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`;
  if (digits.length === 10) return `+1${digits}`;
  return null;
};

const buildEnhancedConversionUserData = (data = {}) => {
  const userData = data.userData || data;
  const {
    email,
    phoneNumber,
    firstName,
    lastName,
    primaryAddress = {},
  } = userData;

  const phoneNumberE164 = normalizePhoneToE164(phoneNumber);
  const address = {
    first_name: firstName || undefined,
    last_name: lastName || undefined,
    street: primaryAddress.street1 || undefined,
    city: primaryAddress.city || undefined,
    region: primaryAddress.stateCode || undefined,
    postal_code: primaryAddress.zipCode || undefined,
    country: 'US',
  };

  Object.keys(address).forEach((key) => address[key] === undefined && delete address[key]);

  const enhancedUserData = {
    email: email || undefined,
    phone_number: phoneNumberE164 || undefined,
    address: Object.keys(address).length ? address : undefined,
  };

  Object.keys(enhancedUserData).forEach((key) => enhancedUserData[key] === undefined && delete enhancedUserData[key]);

  return Object.keys(enhancedUserData).length ? enhancedUserData : null;
};

const bootstrapGTag = () => {
  window.dataLayer = window.dataLayer || [];

  if (typeof window.gtag !== 'function') {
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
  }
};

const loadGTag = (tag_id) => {
  const script = document.createElement('script');

  script.src = `https://www.googletagmanager.com/gtag/js?id=${tag_id}`;
  script.async = true;
  document.head.appendChild(script);
};

if (googleAdManagerId) {
  bootstrapGTag();
  window.gtag('js', new Date());
  window.gtag('config', googleAdManagerId);
  loadGTag(googleAdManagerId);
}

const logEvent = (data = {}) => {
  try {
    if (debugTrackingEnabled()) {
      console.debug(Tracker.name, Tracker.enabled ? 'enabled' : 'disabled', data);
    }
  } catch (e) {
    console.error(Tracker.name, 'Error while logging', e, data);
  }
};

const pushGAMData = (...args) => {
  const gtag = window.gtag || function () {};
  Tracker.enabled && gtag(...args);
  logEvent(...args);
};

const Tracker = {
  name: 'Google Ads Manager',
  enabled: !!googleAdManagerId,
  events: {
    pageView: () => {},
    lead: () => {},
    addToCart: () => {},
    registration: () => {},
    applyPromoCode: () => {},
    checkoutProgress: () => {},
    purchase: ({ transactionId, purchaseAmount, ...userData }) => {
      const enhancedUserData = buildEnhancedConversionUserData(userData);

      if (enhancedUserData) {
        pushGAMData('set', 'user_data', enhancedUserData);
      }

      pushGAMData('event', 'conversion', {
        send_to: `${googleAdManagerId}/SEZtCK3D6-IBEJvEvsUD`,
        value: purchaseAmount,
        currency: 'USD',
        transaction_id: transactionId,
        event_callback: () => {},
      });
    },
    error: () => {},
  },
};

export default Tracker;
